import React, {
  memo,
  FC,
  useCallback,
}                              from 'react';
import { FormikConfig }        from 'formik';
import { Breakpoint }          from '@material-ui/core/styles/createBreakpoints';
import { IBannerAdValues }     from '@typings/nationalAdManagement';
import {
  useFetchBannerAd,
  useSaveBannerAd,
}                              from '@modules/nationalAdManager/queries/nationalAdQueries';
import { Loader }              from '@components/Loader/Loader';
import { BannerEditorWrapper } from '@modules/nationalAdManager/components/BannerEditorWrapper';

interface IProps {
  width        : Breakpoint;
  onCancelEdit : () => void;
}

const BannerEditor: FC<IProps> = ({ width, onCancelEdit }) => {
  // #region API INTEGRATION
  const {
    data: bannerData,
    isLoading,
  } = useFetchBannerAd();

  const { mutateAsync: saveBanner } = useSaveBannerAd();
  // #endregion

  const onSubmitBanner = useCallback<FormikConfig<IBannerAdValues>['onSubmit']>(
    async (values) => {
      await saveBanner(values);
      setTimeout(onCancelEdit, 2000);
    },
    [onCancelEdit, saveBanner],
  );

  if (isLoading) {
    return <Loader />;
  }

  return (
    <BannerEditorWrapper
      width      = {width}
      bannerData = {bannerData ?? null}
      onSubmit   = {onSubmitBanner}
      onCancel   = {onCancelEdit}
    />
  );
};

export const BannerEditorContainer = memo(BannerEditor);
